import { render, staticRenderFns } from "./JobDetailPage.vue?vue&type=template&id=072bdcd6&"
import script from "./JobDetailPage.vue?vue&type=script&lang=js&"
export * from "./JobDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./JobDetailPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports